import React, { useCallback, useEffect, useState } from 'react';
import { debounce } from 'lodash';
import { Textarea } from '@fiverr-private/forms';
import { Container } from '@fiverr-private/layout_components';
import { translate } from '@fiverr-private/i18n-react';
import { T_IDEAL_CANDIDATE_PREFIX } from '../../utils/consts';
import { useIdealCandidateContext } from '../../utils/context';
import { MAX_SKILLS_AND_EXPERIENCE_LENGTH } from '../../constants';

export const SkillsAndExperience = () => {
  const { skillsAndExperience, setSkillsAndExperience } = useIdealCandidateContext();
  const [localValue, setLocalValue] = useState(skillsAndExperience);

  useEffect(() => {
    setLocalValue(skillsAndExperience);
  }, [skillsAndExperience]);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const debouncedSetSkillsAndExperience = useCallback(
    debounce((value: string) => {
      setSkillsAndExperience(value);
    }, 300),
    [setSkillsAndExperience]
  );

  const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    const value = e.target.value;
    setLocalValue(value);
    debouncedSetSkillsAndExperience(value);
  };

  return (
    <Container maxHeight="136px" fontSize="b_md">
      <Textarea
        height="136px"
        placeholder={translate(`${T_IDEAL_CANDIDATE_PREFIX}.skills_and_experience.placeholder`) as string}
        maxLength={MAX_SKILLS_AND_EXPERIENCE_LENGTH}
        value={localValue}
        onChange={handleChange}
      />
    </Container>
  );
};
